import type { Lang } from "../core";
import { common } from "./common";
import { checkout } from "./checkout";
import { thankyou } from "./thankyou";
import { cartRecovery } from "./cartRecovery";
import { bantuan } from "./bantuan";

export type Dict = Record<string, string>;
export type Bilingual = Record<Lang, Dict>;

// Each area file owns a slice of the key namespace (prefixed, e.g. "nav.*",
// "checkout.*"). Keys must be globally unique across area files.
//
// Only the words a buyer's page shows live here, so only they ship in the entry
// bundle: the storefront, checkout and thank-you copy. The dashboard, admin and
// every per-page dictionary — 44% of the entry bundle when they rode in it — are
// in ./full and load with the routes that need them (loadFullMessages in ../core).
// tests/unit/i18nStorefrontCopy.test.ts fails when a buyer page uses a key that
// is not in one of these.
export const coreDicts: Bilingual[] = [common, checkout, thankyou, cartRecovery, bantuan];
